import elementIntersectionObserver from '../../../dom/elementintersectionobserver';

export default function loadProductComponents(productComponents) {
    const observer = elementIntersectionObserver({rootMargin: '500px'});

    Array.from(productComponents).forEach(product => {
        observer(product, () => loadProductComponent(product));
    });
}

function loadProductComponent(product) {
    getProductData(product.dataset.productId).then(response => {
        if (response.Status === 200) {
            addProductContent({
                element: product,
                data: response.Content
            });
        }
    });
}

function getProductData(id) {
    return fetch(`/api/product/getProductClass/${id}`).then(response => response.json());
}

function addProductContent({element, data}) {
    if (/\$0.00/gi.test(data.Price)) {
        return;
    }

    element.innerHTML = `
        <a href="${data.Url}"><img src="${data.ImagePath}?w=80" width="80" height="80" alt="" /></a>
        <div>            
                <div><a href="${data.Url}">${data.Name}</a></div>
                ${data.IsShowFreeShipping ? '<div>This ships free!</div>' : ''}                
                <div><strong>${data.Price}</strong></div>                       
        </div>
    `;
}
